<script>import Arrow from "./Arrow.svelte";
export let clip = "left";
export let variant = "scroll";
export let shape = "rectangle";
export let active = true;
export let disable = false;
export let rotation = 0;
export let platform = "desktop";
</script>

<style>.tile-container {
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-mask-box-image-slice: 20 fill;
          mask-border-slice: 20 fill;
  -webkit-mask-box-image-width: 20px;
          mask-border-width: 20px;
  background-color: hsl(var(--color-N16));
  padding: 3px;
  width: 51px;
  aspect-ratio: 51/47;
  box-sizing: border-box;
}
.tile-container:hover {
  cursor: pointer;
}
.tile-container.square {
  aspect-ratio: 1;
}
.button-container {
  -webkit-mask-box-image-slice: 20 fill;
          mask-border-slice: 20 fill;
  -webkit-mask-box-image-width: 20px;
          mask-border-width: 20px;
  background-color: hsl(var(--color-N08));
  position: relative;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
}
.button-container.square {
  aspect-ratio: 1;
}
.borderClipLeft {
  -webkit-mask-box-image-source: url("./img/NavigateButtonMask-ClipLeft.svg");
  mask-border-source: url("./img/NavigateButtonMask-ClipLeft.svg");
}
.borderClipRight {
  -webkit-mask-box-image-source: url("./img/NavigateButtonMask-ClipRight.svg");
  mask-border-source: url("./img/NavigateButtonMask-ClipRight.svg");
}</style>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class:borderClipLeft={clip === "left"}
  class:borderClipRight={clip === "right"}
  class:square={shape === "square"}
  style="transform: rotate({rotation}deg);"
  class="tile-container"
  on:click>
  <div
    class:borderClipLeft={clip === "left"}
    class:borderClipRight={clip === "right"}
    class:square={shape === "square"}
    class="button-container">
    <Arrow {variant} {active} {disable} {platform} />
  </div>
</div>
